module.exports = __webpack_public_path__ + "img/space-icon.fddc58e8.png";